<template>
  <div class="lotter-config">
    <lotter-conf 
      v-model="luckDraw" 
      :isHasSignUp="isSigup" 
      :isHasreserve="isReserve" 
      ref="lotteryConfRef" 
      :basicInfoForm="basicInfoForm" 
      from="manager"
    />
    <div class="button-box">
      <van-button class="button" color="#ff6b31" type="primary" @click="conserve" >
        确认修改
      </van-button>
    </div>
  </div>
</template>

<script>
import lotterConf from "../activity-management/components/lottery-conf";
import { formatDataLottery } from '../activity-management/utils.js'
export default {
  components: {
    lotterConf,
  },
  data() {
    return {
      luckDraw: {},
			moduleId: '',
      basicInfoForm: {}
    };
  },
  computed: {
    activityId() {
      return this.$route.query.activityId;
    },
    isSigup() {
      return JSON.parse(this.$route.query.isSigup)
    },
    isReserve() {
      return JSON.parse(this.$route.query.isReserve)
    }
  },
  methods: {
    init() {
      this.getLotterConfigData();
    },
    getLotterConfigData() {
      this.$api.luckDraw.lotterConfigData(this.activityId).then((res) => {
        const { startTime,endTime,activityModuleSetups} = res.data
        this.basicInfoForm.startTime = startTime
        this.basicInfoForm.endTime = endTime
				this.moduleId = activityModuleSetups[0].moduleId
        this.luckDraw = formatDataLottery(activityModuleSetups)
      });
    },
		// 保存
    conserve() {
      const lotteryConfRef = this.$refs.lotteryConfRef
      if (lotteryConfRef && !lotteryConfRef.checkValid()){
        return false
      }
      const moduleSetup = this.formaToArra(this.luckDraw);
        this.$api.luckDraw.editActivityLotteryConfig({moduleSetup}).then(res => {
        this.$toast('修改成功')
        setTimeout(()=> {
          this.$router.go(-1)
        },2000)
		  })
    },
    formaToArra(obj) {
      let moduleSetup = [];
      for (let [key, value] of Object.entries(obj)) {
        moduleSetup.push({
          setupColumn: key,
          setupColumnValue: value,
					activityId: this.activityId,
					moduleId: this.moduleId
        });
      }
			return moduleSetup
     
    },
  },

  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.lotter-config {
	.button-box {
		width: 100%;
		padding: 0 20px;

		box-sizing: border-box;
		.button {
			width: 100%;
			margin-bottom: 20px;
		}
	}
}
</style>
